import { useEffect } from "react";

const useTitle = (title) => {
  useEffect(() => {
    document.title = `Muthupalaniappan | ${title}`;
  }, [title]);

  return null;
};

export default useTitle;
